import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { selectBreakManagement } from '../breakManagementSelectors'
import { setForceStopTarget } from '../breakManagementSlice'
import { formatRomeTime } from '../helpers/formatRomeTime'

export interface OperatorRowData {
  breakId: number
  name: string
  department: string
  startTime: string
  onForceStop: () => void
}

const useOperatorsTable = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { breakState, isSubmitting } = useSelector(selectBreakManagement)

  const rows: OperatorRowData[] = (breakState?.operators ?? []).map(operator => ({
    breakId: operator.break_id,
    name: operator.name,
    department: operator.department,
    startTime: formatRomeTime(operator.started_at),
    onForceStop: () => dispatch(setForceStopTarget({ breakId: operator.break_id, name: operator.name })),
  }))

  return { t, rows, isSubmitting }
}

export default useOperatorsTable
